import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';
import Alert from 'react-bootstrap/Alert';
import Image from '../../components/image';
import ProgressBar from 'react-bootstrap/ProgressBar';
import BudgetGraph from '../../assets/img/budget-graph.svg';
import Button from 'react-bootstrap/Button';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import RangeSlider from 'react-bootstrap-range-slider';

class BudgetActions extends React.Component {
    constructor(props) {
        super(props);
        this.handleRangeSlider = this.handleRangeSlider.bind(this);
        this.handleEditBudget = this.handleEditBudget.bind(this);
        this.handleCancelEdit = this.handleCancelEdit.bind(this);
        this.handleAddAlertCondition = this.handleAddAlertCondition.bind(this);
        this.handleRemoveAlertCondition = this.handleRemoveAlertCondition.bind(this);
        this.handleAlertConditionChange = this.handleAlertConditionChange.bind(this);
        this.state = {
            value: 0,
            showEditBudget: false,
            alertConditions: [{ type: 'Forecasted', percent: '', amount: '' }],
            showInfoAlert: true,
            showDangerAlert: true,
            showAllEmails: false
        };
    }
    handleRangeSlider(e) {
        console.log(e);
        this.setState({ value: e })
    }
    handleEditBudget() {
        this.setState({ showEditBudget: true });
    }
    handleCancelEdit() {
        this.setState({ showEditBudget: false });
    }
    handleAddAlertCondition(e) {
        if (e) e.preventDefault();
        this.setState(prevState => ({
            alertConditions: [...prevState.alertConditions, { type: 'Forecasted', percent: '', amount: '' }]
        }));
    }
    handleRemoveAlertCondition(index) {
        this.setState(prevState => ({
            alertConditions: prevState.alertConditions.filter((_, idx) => idx !== index)
        }));
    }
    handleAlertConditionChange(index, field, value) {
        this.setState(prevState => {
            const alertConditions = [...prevState.alertConditions];
            alertConditions[index] = { ...alertConditions[index], [field]: value };
            return { alertConditions };
        });
    }
    render() {
        return (
            <>
                <div className="qd-section_content settings-manage-teammates">
                    <div className="qd-section-header">
                        <h4 className="qd-section-header-title">
                            <i>
                                <FontAwesomeIcon icon={faFileInvoiceDollar} />
                            </i>  Budget & Alert
                        </h4>
                    </div>
                    <div className="qd-section-body pb-4">
                        <div className="">
                            {this.state.showEditBudget ? '' : <p className="p-sm-2">Budgets track expenses within a Qualdo or billing account. Your budget can be a specified amount or based on previous spend. You can set alerts to notify billing admins and users when a budget goes over a specified amount.</p>}
                            {this.state.showEditBudget ? '' :
                                <>
                                    {/* {this.state.showInfoAlert && (
                                        <Alert variant="light" dismissible className="d-flex align-items-center" onClose={() => this.setState({ showInfoAlert: false })}>
                                            <i className="text-info">
                                                <svg id="info_black_24dp_1_" data-name="info_black_24dp (1)" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                                    <path id="Path_37376" data-name="Path 37376" d="M0,0H24V24H0Z" fill="none" />
                                                    <path id="Path_37377" data-name="Path 37377" d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm1,15H11V11h2Zm0-8H11V7h2Z" fill="currentColor" />
                                                </svg>
                                            </i>
                                            <span className="text-dark px-2">Budget evaluations now include reserved instance and purchase charges. To learn more, <button type="button" className="btn btn-link p-0 align-baseline text-underline">visit the budget documentation.</button></span>
                                        </Alert>
                                    )} */}
                                    {this.state.showDangerAlert && (
                                        <Alert variant="danger" dismissible className="d-flex align-items-center" onClose={() => this.setState({ showDangerAlert: false })}>
                                            <i className="text-danger">
                                                <svg id="info_black_24dp_1_" data-name="info_black_24dp (1)" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                                    <path id="Path_37376" data-name="Path 37376" d="M0,0H24V24H0Z" fill="none" />
                                                    <path id="warning_black_24dp_1_" data-name="warning_black_24dp (1)" d="M4.47,21H19.53a2,2,0,0,0,1.73-3L13.73,4.99a2,2,0,0,0-3.46,0L2.74,18a2,2,0,0,0,1.73,3ZM12,14a1,1,0,0,1-1-1V11a1,1,0,0,1,2,0v2A1,1,0,0,1,12,14Zm1,4H11V16h2Z" transform="translate(0 -0.496)" fill="currentColor" />
                                                </svg>
                                            </i>
                                            <span className="px-2">You have reached your budget limit. <button type="button" className="btn btn-link p-0 align-baseline text-underline">Click here to remove your spending limit <i><FontAwesomeIcon icon={faArrowRight} /></i></button></span>
                                        </Alert>
                                    )}
                                </>}
                            <div className={`portlet ${this.state.showEditBudget ? 'd-none' : ''}`}>
                                <div className="portlet-title">
                                    <div className="caption">
                                        <span className="text-uppercase font-dark">Budget Balance</span>
                                    </div>
                                </div>
                                <div className="portlet-body">
                                    <p>Budget amount threshold</p>

                                    {/* Budget Dashboard */}
                                    <div className="budget-dashboard-wrapper">
                                        <div className="row row-sm">
                                            <div className="col-sm-6 col-xl-3">
                                                <div className="budget-dashboard budget-limit-exceeds">
                                                    <div className="budget-dashboard__content">
                                                        <h5 className="budget-dashboard__title">Appx. Spent</h5>
                                                        <span className="budget-dashboard__value">$554.23</span>
                                                        <div class="tw-flex tw-items-center tw-gap-1 tw-mb-[2px] tw-mt-[6px]">
                                                            <span class="tw-text-xs tw-font-medium tw-text-[#808080]">Cloud Cost:</span>
                                                            <span class="tw-text-xs tw-font-semibold tw-text-[#484848]">$354.23</span>
                                                        </div>
                                                        <div class="tw-flex tw-items-center tw-gap-1">
                                                            <span class="tw-text-xs tw-font-medium tw-text-[#808080]">AI Cost:</span>
                                                            <span class="tw-text-xs tw-font-semibold tw-text-[#484848]">$154.23</span>
                                                        </div>
                                                        <small className="validity-text">last update: <span>10 July 2026, 11:44:23</span></small>
                                                    </div>
                                                    <div className="badge bg-danger tw-w-full tw-text-white !tw-font-semibold">
                                                        <i className="text-white mr-1">
                                                            <svg id="info_black_24dp" data-name="info_black_24dp" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                                                <path id="Path_37376" data-name="Path 37376" d="M0,0H24V24H0Z" fill="none" />
                                                                <path id="warning_black_24dp" data-name="warning_black_24dp" d="M4.47,21H19.53a2,2,0,0,0,1.73-3L13.73,4.99a2,2,0,0,0-3.46,0L2.74,18a2,2,0,0,0,1.73,3ZM12,14a1,1,0,0,1-1-1V11a1,1,0,0,1,2,0v2A1,1,0,0,1,12,14Zm1,4H11V16h2Z" transform="translate(0 -0.496)" fill="currentColor" />
                                                            </svg>
                                                        </i>
                                                        <span>Budget limit crossed</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-6 col-xl-3">
                                                <div className="budget-dashboard">
                                                    <div className="budget-dashboard__content">
                                                        <h5 className="budget-dashboard__title">Limit</h5>
                                                        <span className="budget-dashboard__value">$1000</span>
                                                        <small className="validity-text">Limit set on: <span>05 Jan 2026, 17:24:03</span></small>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="budget-dashboard d-flex">
                                                    <div className="budget-dashboard__content">
                                                        <h5 className="budget-dashboard__title">Usage</h5>
                                                        <span className="budget-dashboard__value">45%</span>
                                                        <ProgressBar variant="warning" now={45} />
                                                    </div>
                                                    <div className="budget-dashboard__chart">
                                                        <div className="budget-dashboard__chart-wrap">
                                                            <img src={BudgetGraph} alt="Budget usage graph" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Budget Alert Conditions */}
                                    <h4 className="mb-4 mb-sm-3">Alert Conditions</h4>
                                    <div className="d-sm-flex mb-sm-2">
                                        <div className="user-notify-card">
                                            <label>Email Notification</label>
                                            <div className="card-body">
                                                <div className="card-icon">
                                                    <Image src="icon_email_notify" />
                                                </div>
                                                <p className="card-text">Email notification on <strong>50%</strong></p>
                                            </div>
                                        </div>
                                        <div className="user-notify-card">
                                            <label>Email Notification</label>
                                            <div className="card-body">
                                                <div className="card-icon">
                                                    <Image src="icon_email_notify" />
                                                </div>
                                                <p className="card-text">Email notification on <strong>75%</strong></p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Budget Alerts shared Email */}
                                    <h4 className="mb-3">Budget Alert shared with</h4>
                                    <ul className="qd-tags-group">
                                        <li className="qd-tag">
                                            <span className="qd-tag__label">Admin (sasi@satturam.com)</span>
                                        </li>
                                        <li className="qd-tag">
                                            <span className="qd-tag__label">rajan@saturam.com</span>
                                        </li>
                                        <li className="qd-tag">
                                            <span className="qd-tag__label">Jaipriya@saturam.com</span>
                                        </li>
                                        <li className="qd-tag">
                                            <span className="qd-tag__label">jc@saturam.com</span>
                                        </li>
                                        <li className="qd-tag">
                                            <span className="qd-tag__label">Hasan@saturam.com</span>
                                        </li>
                                        <li className="qd-tag">
                                            <span className="qd-tag__label">Nandhakumar@satturam.com</span>
                                        </li>
                                        <li className="qd-tag">
                                            <span className="qd-tag__label">Viji@satturam.com</span>
                                        </li>
                                        {this.state.showAllEmails && (
                                            <>
                                                <li className="qd-tag">
                                                    <span className="qd-tag__label">shagul@saturam.com</span>
                                                </li>
                                                <li className="qd-tag">
                                                    <span className="qd-tag__label">vijay@saturam.com</span>
                                                </li>
                                                <li className="qd-tag">
                                                    <span className="qd-tag__label">bala@saturam.com</span>
                                                </li>
                                                <li className="qd-tag">
                                                    <span className="qd-tag__label">kiruba@satturam.com</span>
                                                </li>
                                                <li className="qd-tag">
                                                    <span className="qd-tag__label">guru@satturam.com</span>
                                                </li>
                                            </>
                                        )}
                                        <a
                                            href="#!"
                                            className="text-underline pt-1"
                                            onClick={(e) => { e.preventDefault(); this.setState(prev => ({ showAllEmails: !prev.showAllEmails })); }}
                                        >
                                            {this.state.showAllEmails ? 'Show less' : '+5 more emails'}
                                        </a>
                                    </ul>

                                    {/* Alert Box */}
                                    <div className="alert-box mb-4">
                                        <div className="alert-box__content">
                                            <div className="alert-box__icon">
                                                <i className="text-danger d-none">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                                        <g id="info_black_24dp_1_" data-name="info_black_24dp (1)" opacity="0.754">
                                                            <path id="Path_37376" data-name="Path 37376" d="M0,0H24V24H0Z" fill="none" />
                                                            <path id="cancel_FILL1_wght400_GRAD0_opsz24" d="M7.863,16.709a1.058,1.058,0,0,0,1.44,0l2.983-2.983,3.009,3.009A.916.916,0,0,0,16,17a1,1,0,0,0,.706-.295,1.058,1.058,0,0,0,0-1.44l-2.983-2.983,3.009-3.009A.916.916,0,0,0,17,8.569a1,1,0,0,0-.295-.706,1.058,1.058,0,0,0-1.44,0l-2.983,2.983L9.277,7.837a.918.918,0,0,0-.706-.271,1.007,1.007,0,0,0-.708.3,1.058,1.058,0,0,0,0,1.44l2.983,2.983L7.837,15.294A.915.915,0,0,0,7.568,16,1,1,0,0,0,7.863,16.709Zm4.423,5.863a10.011,10.011,0,0,1-4.011-.811A10.263,10.263,0,0,1,2.811,16.3,10.011,10.011,0,0,1,2,12.286a10.011,10.011,0,0,1,.811-4.011A10.269,10.269,0,0,1,8.274,2.809,10.021,10.021,0,0,1,12.286,2a10.021,10.021,0,0,1,4.011.809,10.269,10.269,0,0,1,5.463,5.465,10.011,10.011,0,0,1,.811,4.011,10.011,10.011,0,0,1-.811,4.011A10.263,10.263,0,0,1,16.3,21.761,10.011,10.011,0,0,1,12.286,22.571Z" transform="translate(-0.286 -0.286)" fill="currentColor" />
                                                        </g>
                                                    </svg>
                                                </i>
                                                <i className="text-success">
                                                    <svg id="icon_check-success" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                                        <path id="Path_37376" data-name="Path 37376" d="M0,0H24V24H0Z" fill="none" />
                                                        <path id="check_circle_FILL1_wght400_GRAD0_opsz24" d="M10.846,14.137,8.609,11.9a.943.943,0,0,0-.694-.283.987.987,0,0,0-.72.309,1.058,1.058,0,0,0,0,1.44L10.126,16.3a1.058,1.058,0,0,0,1.44,0L17.4,10.46a.943.943,0,0,0,.283-.694.987.987,0,0,0-.309-.72,1.058,1.058,0,0,0-1.44,0Zm1.44,8.434a10.011,10.011,0,0,1-4.011-.811A10.263,10.263,0,0,1,2.811,16.3,10.011,10.011,0,0,1,2,12.286a10.011,10.011,0,0,1,.811-4.011A10.269,10.269,0,0,1,8.274,2.809,10.021,10.021,0,0,1,12.286,2a10.021,10.021,0,0,1,4.011.809,10.269,10.269,0,0,1,5.463,5.465,10.011,10.011,0,0,1,.811,4.011,10.011,10.011,0,0,1-.811,4.011A10.263,10.263,0,0,1,16.3,21.761,10.011,10.011,0,0,1,12.286,22.571Z" transform="translate(-0.286 -0.286)" fill="currentColor" />
                                                    </svg>
                                                </i>
                                            </div>
                                            <div className="alert-box__text">
                                                <h5>Auto-pause disabled</h5><p>Turning ON Auto-Pause Qualdo Infra may result in a discontinuation of Data Quality,KPI checks and alerts on Datasets and Attributes</p>
                                            </div>
                                        </div>
                                    </div>
                                    <Button variant='primary' className="btn-circle" onClick={this.handleEditBudget}>Edit Budget <FontAwesomeIcon icon={faArrowRight} className="mr-0 ml-1" /></Button>
                                </div>
                            </div>
                        </div>
                        <div className={`portlet ${this.state.showEditBudget ? '' : 'd-none'}`}>
                            <div className="portlet-title">
                                <div className="caption">
                                    <span className="text-info">Edit a budget & Alert</span>
                                    <p>Edit a budget and set alert to help you monitor your costs.</p>
                                </div>
                            </div>
                            <div className="portlet-body">
                                <Row>
                                    <div className="vertical-stepper vertical-stepper-sm vertical-stepper_dashed">
                                        <div className="vertical-stepper__heading">
                                            <span className="vs-heading__circle">1</span>
                                            <span className="vs-heading__title">Budget Amount</span>
                                        </div>
                                        <div className="vertical-stepper__content">
                                            <p className="mb-sm-4">Give your budget amount threshold</p>
                                            <Form.Group as={Row}>
                                                <Form.Label column md={2}><strong>Amount*</strong></Form.Label>
                                                <Col md={4}>
                                                    <Form.Control type="text" placeholder="$500" />
                                                    <Form.Text className="text-muted">Suggested budget: $750 based on forecast</Form.Text>
                                                </Col>
                                            </Form.Group>
                                        </div>
                                        <div className="vertical-stepper__heading">
                                            <span className="vs-heading__circle">2</span>
                                            <span className="vs-heading__title">Set Alerts</span>
                                        </div>
                                        <div className="vertical-stepper__content">
                                            <p className="text-muted mb-sm-4">Configure alert conditions and send email notifications based on your spend.</p>
                                            <h5 className="mb-3">Alert Conditions *</h5>

                                            {this.state.alertConditions.map((condition, index) => (
                                                <Row className="row-sm mb-3" key={index}>
                                                    <Col>
                                                        <Form>
                                                            <Row className="row-sm">
                                                                <Col xs={12} md={4}>
                                                                    <Form.Group controlId={`budgetType-${index}`}>
                                                                        <Form.Label>Type</Form.Label>
                                                                        <Form.Control
                                                                            type="text"
                                                                            name="budgetType"
                                                                            value={condition.type}
                                                                            readOnly
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col xs={6} md={4}>
                                                                    <Form.Group controlId={`budgetPercent-${index}`}>
                                                                        <Form.Label>% of Budget</Form.Label>
                                                                        <Form.Control
                                                                            type="text"
                                                                            name="budgetPercent"
                                                                            placeholder=""
                                                                            value={condition.percent}
                                                                            onChange={e => this.handleAlertConditionChange(index, 'percent', e.target.value)}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col xs={6} md={4}>
                                                                    <Form.Group controlId={`budgetAmount-${index}`}>
                                                                        <Form.Label>Amount</Form.Label>
                                                                        <Form.Control
                                                                            type="text"
                                                                            name="budgetAmount"
                                                                            placeholder=""
                                                                            value={condition.amount}
                                                                            onChange={e => this.handleAlertConditionChange(index, 'amount', e.target.value)}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                            </Row>
                                                        </Form>
                                                    </Col>
                                                    <Col xs={1}>
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={
                                                                <Tooltip>
                                                                    Remove
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <Button variant=" " className="form-remove-btn" onClick={() => this.handleRemoveAlertCondition(index)}></Button>
                                                        </OverlayTrigger>
                                                    </Col>
                                                </Row>
                                            ))}
                                            <div className="mb-4 mb-md-5">
                                                <a href="#!" className="text-underline" onClick={this.handleAddAlertCondition}>
                                                    <i>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                                                            <g id="Group_4911" data-name="Group 4911" transform="translate(-51 -474.87)">
                                                                <rect id="Rectangle_2689" data-name="Rectangle 2689" width="18" height="18" transform="translate(51 474.87)" fill="none" />
                                                                <path id="notification_add_FILL0_wght500_GRAD0_opsz24" d="M4.513,14.825a.834.834,0,0,1-.863-.863.815.815,0,0,1,.244-.6.838.838,0,0,1,.619-.244h.694V8.037A4.632,4.632,0,0,1,8.675,3.5V2.994a1.159,1.159,0,0,1,.366-.863,1.245,1.245,0,0,1,1.744,0,1.16,1.16,0,0,1,.365.863V3.5a4.413,4.413,0,0,1,.872.319,4.291,4.291,0,0,1,.779.488l-.619.619-.619.619a2.924,2.924,0,0,0-.769-.375,3,3,0,0,0-3,.75,2.889,2.889,0,0,0-.881,2.119v5.081h6V11.075h1.706v2.044h.694a.838.838,0,0,1,.619.244.815.815,0,0,1,.244.6.834.834,0,0,1-.863.863Zm5.4,2.269a1.512,1.512,0,0,1-1.1-.45,1.466,1.466,0,0,1-.46-1.088h3.113a1.467,1.467,0,0,1-.459,1.088,1.514,1.514,0,0,1-1.1.45Zm6-6.9a.769.769,0,0,1-.787-.788V7.981H13.7a.788.788,0,1,1,0-1.575h1.425V4.981a.788.788,0,1,1,1.575,0V6.406h1.425a.788.788,0,1,1,0,1.575H16.7V9.406a.769.769,0,0,1-.788.788ZM9.913,9.069Z" transform="translate(48.719 474.436)" fill="currentColor" />
                                                            </g>
                                                        </svg>
                                                    </i> Add alert condition
                                                </a>
                                            </div>

                                            <h5 className="mb-2">Email alerts to billing admins and users *</h5>
                                            <p className="text-muted mb-sm-4">Allow Monitoring email notification channels to receive alerts when this budget reaches thresholds.</p>
                                            <Form.Group>
                                                <Form.Check
                                                    custom
                                                    inline
                                                    label="Admin"
                                                    type="checkbox"
                                                    disabled
                                                    checked
                                                />
                                                <Form.Check
                                                    custom
                                                    inline
                                                    label="Custom Emails"
                                                    type="checkbox"
                                                />
                                            </Form.Group>

                                        </div>
                                        <div className="vertical-stepper__heading">
                                            <span className="vs-heading__circle">3</span>
                                            <span className="vs-heading__title">Pause Qualdo Infra</span>
                                        </div>
                                        <div className="vertical-stepper__content border-0">
                                            <Form.Group>
                                                <Form.Check
                                                    custom
                                                    inline
                                                    label="No Budget Limits"
                                                    type="radio"
                                                />
                                                <Form.Check
                                                    custom
                                                    inline
                                                    label="ON Budget Limits"
                                                    type="radio"
                                                    checked
                                                />
                                            </Form.Group>
                                            <div className="range-slider-container">
                                                <label className="range-slider-label_start">0</label>
                                                <RangeSlider
                                                    value={this.state.value}
                                                    tooltip="on"
                                                    tooltipPlacement="top"
                                                    tooltipLabel={currentValue => `${currentValue}%`}
                                                    min={0}
                                                    max={100}
                                                    onChange={changeEvent =>
                                                        this.handleRangeSlider(changeEvent.target.value)
                                                    }
                                                />
                                                <label className="range-slider-label_end">100</label>
                                            </div>
                                        </div>
                                    </div>
                                </Row>
                                <div className="pt-3">
                                    <Button variant="primary" className="btn-circle mr-2">Save Changes</Button>
                                    <Button className="btn-outline btn-grey btn-circle" onClick={this.handleCancelEdit}>Cancel</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

}

export default BudgetActions;
